const CHANGE_LOAD_VALUES = 'loads/CHANGE_LOAD_VALUES';
const ADD_LOAD = 'loads/ADD_LOAD';
const REMOVE_LOAD = 'loads/REMOVE_LOAD';

const createLoad$ = 'loads/createLoad$';
const deleteLoad$ = 'loads/deleteLoad$';

const changeLoadValue$ = 'loads/changeLoadValue$';
const changeLoadType$ = 'loads/changeLoadType$';
const changePalletType$ = 'loads/changePalletType$';
const changeNonPalletType$ = 'loads/changeNonPalletType$';

const onBlurLoadValue$ = 'loads/onBlurLoadValue$';
const onFocusLoadValue$ = 'loads/onFocusLoadValue$';

const validateForm$ = 'loads/validateForm$';
const setForTest = 'loads/setForTest';

export default {
  CHANGE_LOAD_VALUES,
  ADD_LOAD,
  REMOVE_LOAD,
  createLoad$,
  deleteLoad$,
  changeLoadValue$,
  changeLoadType$,
  changePalletType$,
  changeNonPalletType$,
  onBlurLoadValue$,
  onFocusLoadValue$,
  validateForm$,
  setForTest,
};
